module.exports = __webpack_public_path__ + "img/shutu_chart.2a99744b.svg";